import * as React from "react";
import styled from "styled-components";
import { Row, RowWrapper } from ".";
import { IWithDisabled } from "../../../../ui/_common/IWithDisabled";
import { generic, mobile } from "../../../../ui/_themes/constants";
import { SettingToggle } from "../../../../ui/SettingToggle";
import { E2EIdentifier } from "../../../e2e/E2EIdentifier";
import { Attribute } from "./Attribute";
import { prioritizeRequiredSettings } from "./Autoplay.utils";
import { IAutoplaySetting } from "./AutoplaySettings";

const textColor = generic.autoplaySettings.text.color;
const textActiveColor = generic.autoplaySettings.text.active;
const textBackgroundColor = generic.autoplaySettings.text.background;
const textInvalidColor = generic.autoplaySettings.text.invalid;

export const Toggle = styled(SettingToggle)`
  flex: 0 0 2.4em;
  vertical-align: middle;

  @media (orientation: landscape) {
    width: 2.2em;
  }

  @media (orientation: portrait) {
    width: 2.4em;
  }
`;

export const Label: any = styled.div`
  flex: 0 1 auto;
  user-select: none;
  cursor: pointer;
  font-size: ${mobile.fontSize.s};
  letter-spacing: 0.06em;
  font-weight: 700;
  color: ${({ active }: any) => (active ? textActiveColor : textColor)};
`;

export const RequiredLabel: any = styled<IWithDisabled, "span">("span")`
  position: relative;
  margin-left: 0.7em;
  bottom: 0.2em;
  padding: 0.2em 0.8em;
  border-radius: 0.8em;
  font-size: 0.5em;
  font-weight: 700;
  color: ${textActiveColor};
  background-color: ${props =>
    props.disabled ? textBackgroundColor : textInvalidColor};
`;

export const AutoplaySettings = ({
  settings,
  onChange,
  disabled,
  requiredText
}) => {
  const onToggleChange = setting => () => {
    onChange({
      ...setting,
      active: !setting.active
    });
  };

  // Always push required settings to the top of the stops conditions list
  settings.sort(prioritizeRequiredSettings);

  return (
    <div>
      {settings.map((setting: IAutoplaySetting, index) => {
        const settingRequired =
          setting.attributes && setting.attributes.required;
        const settingDisabled = !settingRequired && !setting.enabled;
        const settingActive = settingRequired || setting.active;
        const toggleDisabled = disabled || settingRequired || !setting.enabled;
        const attributeDisabled = disabled || !settingActive || settingDisabled;
        const showAttribute = setting.attributes && settingActive;

        return (
          <RowWrapper
            key={index}
            data-e2e-id={E2EIdentifier.AUTOPLAY_STOP_CONDITIONS_CONTAINER}
          >
            <Row disabled={settingDisabled}>
              <Label
                onClick={toggleDisabled ? null : onToggleChange(setting)}
                active={settingActive}
              >
                {setting.text}
                {settingRequired && (
                  <RequiredLabel disabled={disabled}>
                    {requiredText}
                  </RequiredLabel>
                )}
              </Label>
              <Toggle
                onToggle={onToggleChange(setting)}
                checked={settingActive}
                disabled={toggleDisabled}
              />
            </Row>
            {showAttribute && (
              <Row disabled={settingDisabled}>
                <Attribute
                  setting={setting}
                  onChange={onChange}
                  disabled={attributeDisabled}
                />
              </Row>
            )}
          </RowWrapper>
        );
      })}
    </div>
  );
};
